import Flowchart from "flowchart-react";
import React from 'react';
import Uploader from 'react-images-upload';
//https://github.com/atlassian/react-beautiful-dnd
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
//http://casesandberg.github.io/react-color/
import { SketchPicker } from 'react-color';
//npm i @ckeditor/ckeditor5-build-classic@36.0.0
//npm i @ckeditor/ckeditor5-react@5.0.6
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Chart, Pie } from 'react-chartjs-2';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';

ChartJS.register(...registerables);


export default class Questionnaire extends Base {
    constructor(props) {
        super(props);
        this.state = {
            questionIdToRemove: null,
            tempRecord: null,
            activeQuestionWindow: null,
            startPage: null,
            conditions: null,
            finishPage: null,
            prizePage: null,
            emailPage: null,
            settings: null,
            flowchart: null,
            id: props.Id,
            reports: null,
            reportData: null,
            iframe: null,
            showPreviewInPopup: true,
            settingActiveTab: 1,
            questionDragged: null,
            hasActiveHTTP: 0,
            showReadyOptions: 1,
            inviteMobileNo: '',
            inviteEditPermission: 0,
            loading: true,
            systemModuleId: 32,
            moduleAccessStatus: 1,
        };


        this.onDropPic = this.onDropPic.bind(this);
        this.onDropPic2 = this.onDropPic2.bind(this);
        this.onDropPic3 = this.onDropPic3.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onDragEndOptions = this.onDragEndOptions.bind(this);
        this.onDragEndColumns = this.onDragEndColumns.bind(this);
    }
    loadQuestionDropDownItems(question) {
        if (this.isEmpty(question.options)) return [];
        var items = [];
        question.options.forEach(opt => {
            items.push({ value: (question.pointEnable == 1 ? opt.value : opt.text), label: opt.text });
        });
        return items;
    }
    getImageDimensions(file) {
        return new Promise(function (resolved, rejected) {
            var i = new Image()
            i.onload = function () {
                resolved({ w: i.width, h: i.height })
            };
            i.src = file
        })
    }
    onDropPic(picture) {
        if (picture == null || picture == undefined || picture == '') return;
        let reader = new FileReader();
        let file = picture[0];
        reader.onloadend = () => {
            this.getImageDimensions(reader.result)
                .then(dimensions => {
                    this.state.activeQuestionWindow.cover = {
                        s: reader.result,
                        w: dimensions.w,
                        h: dimensions.h
                    };
                    this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
                });
        }
        if (file && file.type.match('image.*')) {
            reader.readAsDataURL(file);
        }
        else {
            this.showErorrMessage("فرمت عکس ارسالی نامعتبر است");
        }
    }
    onDropPic2(picture) {
        if (picture == null || picture == undefined || picture == '') return;
        let reader = new FileReader();
        let file = picture[0];
        reader.onloadend = () => {
            this.getImageDimensions(reader.result)
                .then(dimensions => {
                    this.setTempRecordValue('startPageCover', {
                        s: reader.result,
                        w: dimensions.w,
                        h: dimensions.h
                    });
                });
        }
        if (file && file.type.match('image.*')) {
            reader.readAsDataURL(file);
        }
        else {
            this.showErorrMessage("فرمت عکس ارسالی نامعتبر است");
        }
    }
    onDropPic3(picture) {
        if (picture == null || picture == undefined || picture == '') return;
        let reader = new FileReader();
        let file = picture[0];
        reader.onloadend = () => {
            this.getImageDimensions(reader.result)
                .then(dimensions => {
                    this.setTempRecordValue('finishPageCover', {
                        s: reader.result,
                        w: dimensions.w,
                        h: dimensions.h
                    });
                });
        }
        if (file && file.type.match('image.*')) {
            reader.readAsDataURL(file);
        }
        else {
            this.showErorrMessage("فرمت عکس ارسالی نامعتبر است");
        }
    }
    getQuestionMaxPosition() {
        var p = 0;
        this.state.data.record.questions.forEach(q => {
            if (q.position > p) p = q.position;
        });
        return p;
    }
    addQuestion(fieldType, questionToCopy = null) {
        if (!this.isNull(questionToCopy)) fieldType = questionToCopy.fieldType;

        var q = {
            id: this.uuidv4(),
            questionnaireId: this.state.data.record.id,
            question: "",
            questionDesc: "",
            options: [],
            position: this.getQuestionMaxPosition() + 1,
            fieldType: fieldType,
            columns: ((fieldType === 4) ? [] : ""),
            conditions: [],
            required: 0,
            showNumber: 1,
            format: ((fieldType == 1 || fieldType == 2 || fieldType == 4) ? 1 : null),
            cover: {
                s: '',
                w: 0,
                h: 0
            },
            range: '',
            maxSelect: 1,
            pointEnable: 1
        }
        if (!this.isNull(questionToCopy)) {
            q = { ...questionToCopy };
            q.id = this.uuidv4();
            q.position = this.getQuestionMaxPosition() + 1;
        }
        this.editQuestion(q);
        //this.state.data.record.questions.push(question);
        //this.setState({ data: this.state.data });
    }
    removeQuestion(question) {
        var questions = [];
        var positionCounter = 0;
        this.state.data.record.questions.sort((a, b) => a.position - b.position).forEach(q => {
            if (q.id !== question.id) {
                positionCounter++;
                q.position = positionCounter;
                questions.push(q);
            }
        });
        this.state.data.record.questions = questions;
        this.setState({ data: this.state.data });
    }
    getBodyItem() {
        return {
            title: this.state.data.record.title,
            desc: this.state.data.record.desc,
            type: this.state.data.record.type,
            startPageDisplay: this.state.data.record.startPageDisplay,
            startPageCaption: this.state.data.record.startPageCaption,
            startPageDescription: this.state.data.record.startPageDescription,
            finishPageDisplay: this.state.data.record.finishPageDisplay,
            finishPageCaption: this.state.data.record.finishPageCaption,
            finishPageDescription: this.state.data.record.finishPageDescription,
            lang: this.state.data.record.lang,
            nextButton: this.state.data.record.nextButton,
            category: this.state.data.record.category,
            prevButton: this.state.data.record.prevButton,
            showQuestionCount: this.state.data.record.showQuestionCount,
            displayMode: this.state.data.record.displayMode,
            titleDisplay: this.state.data.record.titleDisplay, 
            displayResualt: this.state.data.record.displayResualt,
            startPageCover: this.state.data.record.startPageCover,
            finishPageCover: this.state.data.record.finishPageCover,
            style: this.state.data.record.style,
            configs: this.state.data.record.configs,
            notifications: this.state.data.record.notifications,
        };
    } 
    create() {
        if (this.state.hasActiveHTTP == 1) return;
        var body = this.getBodyItem();
        body.finishPageCover = JSON.stringify(body.finishPageCover);
        body.startPageCover = JSON.stringify(body.startPageCover);
        body.style = JSON.stringify({
            questionColor: '',
            answerColor: '',
            focusColor: '',
            buttonColor: '',
            buttonBackgroundColor: '',
            backgroundColor: ''
        });
        body.configs = JSON.stringify({
            startButtonCaption: 'شروع تکمیل پرسشنامه'
        });
        body.notifications = JSON.stringify({
            clientEmail: 0,
            clientEmailContent: "",
            clientEmailSubject: "",
            designerEmail: 0,
            designerEmailContent: "",
            designerEmailSubject: ""
        });
        this.httpPost('api/v1/questionnaire/create', body)
            .then((resualt) => {
                if (resualt.status === 1) {
                    window.location.href = "/questionnaire/edit/" + resualt.record + "/";
                    //this.setState({
                    //    redirect: "/questionnaire/edit/" + resualt.record + "/"
                    //});
                }
                else
                    this.showErorrMessage(resualt.message);
            })
    }
    save() {
        var body = this.getBodyItem();
        body.finishPageCover = JSON.stringify(body.finishPageCover);
        body.startPageCover = JSON.stringify(body.startPageCover);
        body.style = JSON.stringify(body.style);
        body.notifications = JSON.stringify(body.notifications);
        body.configs = JSON.stringify(body.configs);
        body.id = this.state.data.record.id;
        this.httpPost('api/v1/questionnaire/save',body)
            .then((resualt) => {
                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    //this.state.data.record = resualt.record;
                    //this.state.data = this.jsonConverts(this.state.data);
                    this.setState({
                        startPage: null,
                        finishPage: null,
                        prizePage: null,
                        emailPage: null,
                        conditions: null,
                        settings: null,
                        flowchart: null,
                        data: this.state.data
                    });
                }
                else
                    this.showErorrMessage(resualt.message);
            });
    }
    publish() {        
        this.httpPost('api/v1/questionnaire/publish', {
            id: this.state.data.record.id,
        })
            .then((resualt) => {                
                if (resualt.status === 1) {
                    this.showSuccessMessage("پرسشنامه منتشر گردید و آماده دریافت نظرات است.");
                }
                else
                    this.showErorrMessage(resualt.message);
            })
    }
    saveQuestion() {
        if (this.state.hasActiveHTTP == 1) return;

        var temp = { ...this.state.activeQuestionWindow };
        temp.columns = JSON.stringify(temp.columns);
        temp.conditions = JSON.stringify(temp.conditions);
        temp.cover = JSON.stringify(temp.cover);

        if (temp.fieldType === 4) {
            for (var i = 0; i < temp.options.length; i++) {
                temp.options[i].value = JSON.stringify(temp.options[i].value);
            }
        }

        this.httpPost('api/v1/questionnaire/savequestion', {
            question: temp
        })
            .then((resualt) => {
                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    this.state.data.record = resualt.record;
                    this.state.data = this.jsonConverts(this.state.data);
                    this.setState({ activeQuestionWindow: null, data: this.state.data });
                }
                else
                    this.showErorrMessage(resualt.message);
            })
    }
    saveCondition() {
        if (this.state.hasActiveHTTP == 1) return;
                
        this.httpPost('api/v1/questionnaire/savecondition', {
            id: this.state.data.record.id,
            questionId: this.state.conditions.id,
            conditions: JSON.stringify(this.state.conditions.conditions)
        })
            .then((resualt) => {               
                
                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    this.state.data.record = resualt.record;
                    this.state.data = this.jsonConverts(this.state.data);
                    this.setState({ conditions: null, data: this.state.data });
                }
                else
                    this.showErorrMessage(resualt.message);
            })
    }
    doRemoveQuestion() {
        if (this.state.hasActiveHTTP == 1) return;        
        
        this.httpPost('api/v1/questionnaire/removequestion', {
            id: this.state.data.record.id,
            questionId: this.state.questionIdToRemove
        })
            .then((resualt) => {              

                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    this.state.data.record = resualt.record;
                    this.state.data = this.jsonConverts(this.state.data);
                    this.setState({ questionIdToRemove: null, data: this.state.data });
                }
                else
                    this.showErorrMessage(resualt.message);
            });
    }
    savePrizeConfig() {
        if (this.state.hasActiveHTTP == 1) return;        
        
        this.httpPost('api/v1/questionnaire/update/prize', {
            id: this.state.data.record.id,
            payPrize: this.state.tempRecord.payPrize,
            creditToPrize: this.state.tempRecord.creditToPrize,
        })
            .then((resualt) => {               

                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    this.state.data.record = resualt.record;

                    this.state.data = this.jsonConverts(this.state.data);
                    this.setState({
                        startPage: null,
                        finishPage: null,
                        prizePage: null,
                        emailPage: null,
                        conditions: null,
                        settings: null,
                        flowchart: null,
                        data: this.state.data
                    });
                }
                else
                    this.showErorrMessage(resualt.message);
            });
    }
    saveEmailConfig() {
        if (this.state.hasActiveHTTP == 1) return;
        
        
        this.httpPost('api/v1/questionnaire/update/notifications', {
            id: this.state.data.record.id,
            notifications: this.state.tempRecord.notifications,
        })
            .then((resualt) => {
               

                if (resualt.status === 1) {
                    this.showSuccessMessage("تغییرات با موفقیت ذخیره گردید");
                    this.state.data.record = resualt.record;

                    this.state.data = this.jsonConverts(this.state.data);
                    this.setState({
                        startPage: null,
                        finishPage: null,
                        prizePage: null,
                        emailPage: null,
                        conditions: null,
                        settings: null,
                        flowchart: null,
                        data: this.state.data
                    });
                }
                else
                    this.showErorrMessage(resualt.message);
            });
    }
    copyToTemp() {
        this.state.tempRecord = { ...this.state.data.record };
        delete this.state.tempRecord.questions;
    }
    getQuestionIndexById(id) {
        var index = -1;
        var q = this.state.data.record.questions;
        for (var i = 0; i < q.length; i++) {
            if (q[i].id === id) index = i;
        }
        return index;
    }
    getOptionMaxPosition(question) {
        var p = 0;
        question.options.forEach(q => {
            if (q.position > p) p = q.position;
        });
        return p;
    }
    addOption(textList = []) {

        if (this.isEmpty(textList)) {
            var options = {
                id: this.uuidv4(),
                text: '',
                value: ((this.state.activeQuestionWindow.fieldType === 4) ? [] : 0),
                position: this.getOptionMaxPosition(this.state.activeQuestionWindow) + 1
            }

            this.state.activeQuestionWindow.options.push(options);
        }
        else {
            textList.forEach(txt => {
                var options = {
                    id: this.uuidv4(),
                    text: txt.text,
                    value: ((this.state.activeQuestionWindow.fieldType === 4) ? [] : 0),
                    position: this.getOptionMaxPosition(this.state.activeQuestionWindow) + 1
                }

                this.state.activeQuestionWindow.options.push(options);
            })
        }
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    addCondition() {
        var condition = {
            id: this.uuidv4(),
            type: 1,
            value: 0,
            op: 1
        }
        this.state.conditions.conditions.push(condition);
        this.setState({ conditions: this.state.conditions });
    }
    removeOption(opt) {
        var options = [];
        this.state.activeQuestionWindow.options.forEach(o => {
            if (o.id !== opt.id) {
                options.push(o);
            }
        });
        this.state.activeQuestionWindow.options = options;

        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    removeCondition(condition) {
        var conditions = [];
        this.state.conditions.conditions.forEach(o => {
            if (o.id !== condition.id) {
                conditions.push(o);
            }
        });
        this.state.conditions.conditions = conditions;

        this.setState({ conditions: this.state.conditions });
    }
    setQuestionValue(field, e) {
        if (field == 'cover')
            this.state.activeQuestionWindow[field] = e;
        else {
            if (field == 'required' || field == 'showNumber' || field == 'pointEnable')
                this.state.activeQuestionWindow[field] = e.target.checked ? 1 : 0;
            else {
                if (field == 'format')
                    this.state.activeQuestionWindow[field] = parseInt(e.target.value);
                else
                    this.state.activeQuestionWindow[field] = e.target.value;
            }
        }
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    getColumnMaxPosition(question) {
        var p = 0;
        question.columns.forEach(q => {
            if (q.position > p) p = q.position;
        });
        return p;
    }
    addColumns() {
        this.state.activeQuestionWindow.columns.push({
            id: this.uuidv4(),
            position: this.getColumnMaxPosition(this.state.activeQuestionWindow) + 1,
            caption: 'عنوان ستون'
        });
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    removeColumn(i) {
        var columns = [];
        this.state.activeQuestionWindow.columns.forEach((c, index) => {
            if (index !== i) {
                columns.push(c);
            }
        });
        this.state.activeQuestionWindow.columns = columns;

        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    setOptionValue(option, e) {
        this.state.activeQuestionWindow.options.forEach((o, i) => {
            if (o.id == option.id) this.state.activeQuestionWindow.options[i].value = e;
        });
    }
    setOptionText(option, e) {
        this.state.activeQuestionWindow.options.forEach((o, i) => {
            if (o.id == option.id) this.state.activeQuestionWindow.options[i].text = e;
        });
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    setOptionAvatar(option, e) {
        this.state.activeQuestionWindow.options.forEach((o, i) => {
            if (o.id == option.id) this.state.activeQuestionWindow.options[i].avatar = e;
        });
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    setConditionValue(condition, field, e) {
        this.state.conditions.conditions.forEach((o, i) => {
            if (o.id == condition.id) this.state.conditions.conditions[i][field] = e;
        });
        this.setState({ conditions: this.state.conditions });
    }
    removeQuestion(question) {
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: null, settings: null, flowchart: null, reports: null, iframe: null, questionIdToRemove: question.id });
    }
    editQuestion(question) {
        var copy = { ...question };
        this.state.showReadyOptions = 0;
        this.setState({ activeQuestionWindow: copy, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: null, settings: null, reports: null, iframe: null, questionIdToRemove: null });
    }
    showConditions(question) {
        var copy = { ...question };
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: copy, settings: null, flowchart: null, reports: null, iframe: null, questionIdToRemove: null })
    }
    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        var target_index = result.destination.index;
        var draged_index = result.source.index;

        if (target_index == draged_index) return;

        var position = this.state.data.record.questions[target_index].position;
        this.state.data.record.questions[target_index].position = this.state.data.record.questions[draged_index].position;
        this.state.data.record.questions[draged_index].position = position;

        this.setState({ data: this.state.data });

        this.httpPost('api/v1/questionnaire/questionposition/', {
            id: this.state.data.record.id,
            questionId_1: this.state.data.record.questions[draged_index].id,
            position_1: this.state.data.record.questions[draged_index].position,
            questionId_2: this.state.data.record.questions[target_index].id,
            position_2: this.state.data.record.questions[target_index].position,
        })
            .then((resualt) => {
            })
            .catch((error) => {
            });
    }
    renderQuestion(question) {
        return <div className='drag-item q-item' key={question.id}>
            <label onClick={e => this.editQuestion(question)} className='hand text-sm text-center bg-gray-200 p-2 flex flex-row'>
                {question.fieldType === 1 && <svg className="h-4 w-4 mx-1" viewBox="0 0 24 24">{this.getSVGIcon("text")}</svg>}
                {question.fieldType === 2 && <svg className="h-4 w-4 mx-1" viewBox="0 0 24 24">{this.getSVGIcon("check_multi")}</svg>}
                {question.fieldType === 4 && <svg className="h-4 w-4 mx-1" viewBox="0 0 24 24">{this.getSVGIcon("check_matris_multi")}</svg>}
                {question.fieldType === 7 && <svg className="h-4 w-4 mx-1" viewBox="0 0 24 24">{this.getSVGIcon("memo")}</svg>}
                <span className='font-bold'>{question.position}</span>
            </label>
            <div className='bg-gray-100 py-1 px-1 text-center font-bold'>
                <div className='flex flex-row'>
                    <a className='mx-1 hand' title='تغییر اولویت سوال (با کشیدن و جابجایی سوالات)'>{this.getSVGIcon("sort", "inline h-4 w-4 move")}</a>
                    <a className='mx-1 hand' title='شرط گذاری' onClick={e => this.showConditions(question)}>{this.getSVGIcon("condition", "inline h-4 w-4 " + (question.conditions.length > 0 ? " text-red-600 fill-current" : ""))}</a>
                </div>
            </div>
            <p onClick={e => this.editQuestion(question)} className="hand flex flex-wrap text-black" style={{ "line-height": "40px" }}>
                {question.required === 1 && <span className='text-red-600 mx-1'>*</span>}
                <span className='px-1' dangerouslySetInnerHTML={{ __html: question.question }}></span>
            </p>
            <div className='overly-tools'>
                <a className='mx-1 hand' title='حذف سوال' onClick={e => this.removeQuestion(question)}>{this.getSVGIcon("trash", "inline h-4 w-4 text-red-600 fill-current")}</a>
                <a className='mx-1 hand' title='ایجاد سوال جدید از روی همین سوال' onClick={e => this.addQuestion(null, question)}>{this.getSVGIcon("copy", "inline h-4 w-4 fill-current")}</a>
            </div>
        </div>;
    }
    showStartPage() {
        this.copyToTemp();
        this.setState({ activeQuestionWindow: null, startPage: 1, finishPage: null, prizePage: null, emailPage: null });
    }
    renderStartPage() {
        return <div className='mt-4 mb-4 border-b-1 questionnaire_tour_2'>
            <div className='flex flex-row'>
                <div className='bg-gray-100 py-1 px-1 text-center font-bold'>
                    <div className='flex flex-row'>
                        <a onClick={e => this.showStartPage()} className='mx-1 hand' title='تنظیمات'>{this.getSVGIcon("cog", "inline h-4 w-4")}</a>
                    </div>
                </div>
                <label className='text-sm text-center bg-gray-200 p-2 block hand' onClick={e => this.showStartPage()}>صفحه خوش آمد گویی</label>
            </div>
        </div>;
    }
    showFinishPage() {
        this.copyToTemp();
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: 1, prizePage: null, emailPage: null });
    }
    showPrizePage() {
        this.copyToTemp();
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: 1, emailPage: null });
    }
    showEmailPage() {
        this.copyToTemp();
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: 1 });
    }
    renderFinishPage() {
        return <div className='flex flex-row'>
            <div className='my-4 border-b-1 questionnaire_tour_9'>
                <div className='flex flex-row'>
                    <div className='bg-gray-100 py-1 px-1 text-center font-bold'>
                        <div className='flex flex-row'>
                            <a onClick={e => this.showFinishPage()} className='mx-1 hand' title='تنظیمات صفحه'>{this.getSVGIcon("cog", "inline h-4 w-4")}</a>
                        </div>
                    </div>
                    <label className='text-sm text-center bg-gray-200 p-2 block hand' onClick={e => this.showFinishPage()}>صفحه تشکر و پایان</label>
                </div>
            </div>
            {/*<div className='mr-4 my-4 border-b-1 questionnaire_tour_10'>*/}
            {/*    <div className='flex flex-row'>*/}
            {/*        <div className='bg-gray-100 py-1 px-1 text-center font-bold'>*/}
            {/*            <div className='flex flex-row'>*/}
            {/*                <a onClick={e => this.showPrizePage()} className='mx-1 hand' title='تنظیمات'>{this.getSVGIcon("cog", "inline h-4 w-4")}</a>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <label className='text-sm text-center bg-gray-200 p-2 block hand' onClick={e => this.showPrizePage()}>پاداش و هدیه</label>*/}
            {/*    </div>*/}
            {/*</div>*/}
            {/*<div className='mr-4 my-4 border-b-1 questionnaire_tour_11'>*/}
            {/*    <div className='flex flex-row'>*/}
            {/*        <div className='bg-gray-100 py-1 px-1 text-center font-bold'>*/}
            {/*            <div className='flex flex-row'>*/}
            {/*                <a onClick={e => this.showEmailPage()} className='mx-1 hand' title='تنظیمات'>{this.getSVGIcon("cog", "inline h-4 w-4")}</a>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <label className='text-sm text-center bg-gray-200 p-2 block hand' onClick={e => this.showEmailPage()}>ایمیل ها و اطلاع رسانی ها</label>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    }
    setFormFields(fieldName, t) {
        var partialState = {};
        partialState[fieldName] = t.target.value;
        this.setState(partialState);
    }
    showSettings() {
        this.copyToTemp();
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: null, settings: 1, flowchart: null, colorPopup: 0, reports: null, iframe: null, questionIdToRemove: null });
    }
    showFlowChart() {
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: null, settings: null, flowchart: 1, colorPopup: 0, reports: null, iframe: null, questionIdToRemove: null });
    }
    renderForm() {
        return <div className="container mx-auto" style={{ "font-size": "1rem", "line-height": "2rem" }}>
            <div className="mx-auto p-2 my-4 bg-white dark:bg-light-600 rounded shadow-me text-color-base dark:text-color-base-dark relative border">
                {this.state.id === this.getDefaultGuid() &&
                    <div>
                        <div className='flex flex-col space-y-4 min my-8 mb-2'>
                            <div>
                                <p>عنوان پرسشنامه</p>
                                <input maxLength="400" type="text" className="form-control" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} minLength="2" placeholder="وارد کردن عنوان پرسشنامه الزامی است" required />
                            </div>
                        </div>
                        <span onClick={e => this.create()} className="btn btn-success">شروع</span>
                    </div>
                }
                {this.state.id !== this.getDefaultGuid() &&
                    <div>
                        <div className="questionnaire_side questionnaire_tour_1">
                            <div className='flex flex-col text-center space-y-3'>
                                <label className="p-2 bg-white mx-2 hand" onClick={e => this.addQuestion(1)} title="سوال تکی">
                                    <span className="step-box-icon">
                                        <svg className="h-6 w-6 mx-auto fill-current" viewBox="0 0 24 24">{this.getSVGIcon("text")}</svg>
                                    </span>
                                    <span>سوال تکی</span>
                                </label>
                                <label className="p-2 bg-white mx-2 hand" onClick={e => this.addQuestion(2)} title="سوال چند گزینه ای ">
                                    <span className="step-box-icon">
                                        <svg className="h-6 w-6 mx-auto fill-current" viewBox="0 0 24 24">{this.getSVGIcon("check_multi")}</svg>
                                    </span>
                                    <span>چند گزینه ای</span>
                                </label>
                                <label className="p-2 bg-white mx-2 hand" onClick={e => this.addQuestion(4)} title="ماتریس">
                                    <span className="step-box-icon">
                                        <svg className="h-6 w-6 mx-auto fill-current" viewBox="0 0 24 24">{this.getSVGIcon("check_matris_multi")}</svg>
                                    </span>
                                    <span>ماتریس</span>
                                </label>
                                <label className="p-2 bg-white mx-2 hand" onClick={e => this.addQuestion(7)} title="متن">
                                    <span className="step-box-icon">
                                        <svg className="h-6 w-6 mx-auto fill-current" viewBox="0 0 24 24">{this.getSVGIcon("memo")}</svg>
                                    </span>
                                    <span>متن</span>
                                </label>
                            </div>
                        </div>
                        <div className='questionnaire_content'>
                            <p onClick={e => this.showSettings()} className='mt-8 mb-4 hand'>عنوان پرسشنامه: {this.state.data.record.title}</p>
                            {this.renderStartPage()}
                            <DragDropContext onDragEnd={this.onDragEnd}>
                                <Droppable droppableId="droppable">
                                    {(provided, snapshot) => (
                                        <div
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            style={{ "background": (snapshot.isDraggingOver ? "#e5e7eb" : "") }}
                                        >
                                            {this.state.data.record.questions.sort((a, b) => (a.position - b.position)).map((item, index) => (
                                                <Draggable key={"question-" + item.id} draggableId={"question-" + item.id} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={
                                                                {
                                                                    border: snapshot.isDragging ? "solid 1px" : "",
                                                                    userSelect: "none",
                                                                    padding: 0,
                                                                    margin: `0`,
                                                                    background: snapshot.isDragging ? "#bbbbbb" : "",
                                                                    ...provided.draggableProps.style
                                                                }}
                                                        >
                                                            {this.renderQuestion(item)}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            {this.renderFinishPage()}
                        </div>
                        <div className='absolute top-2 left-0 flex flex'>
                            <a href={"/q/" + this.state.data.record.id + "/"} target="_blank" className="questionnaire_tour_8 hand px-2 py-1" title='مشاهده پرسشنامه'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("eye")}</svg></a>
                            <span onClick={e => this.getIframe()} className="questionnaire_tour_7 hand px-2 py-1" title='دریافت کد نمایش بر روی سایت'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("share")}</svg></span>
                            <a href={"/questionnaire/" + this.state.data.record.id + "/excel/"} target="_blank" download="download" className="questionnaire_tour_6 hand px-2 py-1" title='دریافت اکسل نتایج'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("file-chart-pie")}</svg></a>
                            <span onClick={e => this.getReport()} className="questionnaire_tour_5 hand px-2 py-1" title='گزارش'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("chart-pie")}</svg></span>
                            <span onClick={e => this.showSettings()} className="questionnaire_tour_4 hand px-2 py-1" title='تنظیمات'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("cog")}</svg></span>
                            <span onClick={e => this.showFlowChart()} className="questionnaire_tour_4 hand px-2 py-1" title='فلوچارت نمایش سوالات'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("flowchart")}</svg></span>
                            {this.state.data.record.status !== 2 && <span onClick={e => this.publish()} className="questionnaire_tour_3 hand px-2 py-1 text-green-600 fill-current" title='انتشار'><svg className="h-6 w-6" viewBox="0 0 24 24">{this.getSVGIcon("check")}</svg></span>}
                        </div>
                    </div>
                }
            </div>
        </div>
    }
    setColumnValue(i, e) {
        this.state.activeQuestionWindow.columns[i].caption = e;
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    onDragEndOptions(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        var target_index = result.destination.index;
        var draged_index = result.source.index;

        if (target_index == draged_index) return;
        var tempPosition = this.state.activeQuestionWindow.options[target_index].position;
        this.state.activeQuestionWindow.options[target_index].position = this.state.activeQuestionWindow.options[draged_index].position;
        this.state.activeQuestionWindow.options[draged_index].position = tempPosition;

        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    renderOptionsMatrix() {
        var question = this.state.activeQuestionWindow;
        var res = [<span className="font-bold">{question.fieldType === 4 ? "ردیف های ماتریس" : "لیست پاسخهای تعریف شده"}</span>];

        if (this.isEmpty(question.options)) {
            res.push(<div style={{ "background-color": "rgb(240, 242, 245)" }} className="text-center font-bold p-2">{question.fieldType === 4 ? "شما هنوز ردیفی اضافه نکرده اید" : "شما هنوز پاسخی تعریف نکرده اید"}</div>);
        }
        else {
            var options = [];
            question.options.sort((a, b) => (a.position - b.position)).map((opt, index) => {
                options.push(<Draggable key={"options-" + opt.id} draggableId={"options-" + opt.id} index={index}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={
                                {
                                    border: snapshot.isDragging ? "solid 1px" : "",
                                    userSelect: "none",
                                    padding: 0,
                                    margin: `0`,
                                    background: snapshot.isDragging ? "#bbbbbb" : "",
                                    ...provided.draggableProps.style
                                }}>
                            <div key={opt.id} className="flex flex-row my-2">
                                <div className='flex flex-row w-full q-input-wrapper'>
                                    <span>{this.getSVGIcon("sort", "inline h-4 w-4 move")}</span>
                                    {question.format == 6 && [
                                        <span>آواتار</span>,
                                        <div className='q-avatar-selector'>
                                            <img src={'https://panel.domain.com/media/avatars/' + (this.isBlank(opt.avatar) ? "_default.svg" : opt.avatar)} style={{ "width": "25px", "margin-top": "3px" }} />
                                            <div className='grid grid-cols-12 gap-1 p-1'>
                                                {this.state.data.avatars.map(avatar => <img onClick={e => this.setOptionAvatar(opt, avatar)} src={'https://panel.domain.com/media/avatars/' + avatar} />)}
                                            </div>
                                        </div>
                                    ]}
                                    <span>متن</span>
                                    <input type="text" defaultValue={opt.text} onChange={e => this.setOptionText(opt, e.target.value)} minLength="2" className={"w-full text-center focus:border-brand focus:ring-0 dark:focus:border-brand-dark dark:border-light-700 border-gray-300 p-0"} />
                                </div>
                                {question.pointEnable === 1 && (question.format == 1 || question.format == 2 || question.format == 3) &&
                                    <div className='flex flex-row md:mx-2 q-input-wrapper'>
                                        <span>امتیاز</span>
                                        <input type="number" defaultValue={opt.value} onChange={e => this.setOptionValue(opt, e.target.value)} min={0} className="text-center w-12 focus:border-brand focus:ring-0 dark:focus:border-brand-dark dark:border-light-700 border-gray-300 p-0 " />
                                    </div>
                                }
                                <span className='fill-current p-1 hand' onClick={e => this.removeOption(opt)} style={{ "background-color": "#f0f2f5", "border-radius": "0.25rem" }}>{this.getSVGIcon("trash", "inline h-4 w-4 mx-1")} </span>
                            </div>
                        </div>
                    )}
                </Draggable>
                );
            });

            res.push(<DragDropContext onDragEnd={this.onDragEndOptions}>
                <Droppable droppableId="droppableOptions">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {options}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>);
        }
        res.push(<div className='flex flex-row items-center'>
            <span className='hand mx-1 p-2 rounded bg-green-600 text-white transition-all duration-200 ease-in-out text-xs w-24 mt-2' onClick={e => this.addOption()}>{this.getSVGIcon("plus", "inline h-4 w-4")}{this.state.activeQuestionWindow.fieldType === 4 ? "ردیف جدید" : "پاسخ جدید"}</span>
        </div>);
        return res;
    }
    onDragEndColumns(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        var target_index = result.destination.index;
        var draged_index = result.source.index;

        if (target_index == draged_index) return;

        var tempPosition = this.state.activeQuestionWindow.columns[target_index].position;
        this.state.activeQuestionWindow.columns[target_index].position = this.state.activeQuestionWindow.columns[draged_index].position;
        this.state.activeQuestionWindow.columns[draged_index].position = tempPosition;

        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    renderColumnsMatrix() {
        var question = this.state.activeQuestionWindow;
        var res = [<span className="font-bold">ستون های ماتریس</span>];

        if (this.isEmpty(question.columns)) {
            res.push(<div style={{ "background-color": "rgb(240, 242, 245)" }} className="text-center font-bold p-2">شما هنوز ستونی تعریف نکرده اید</div>);
        }
        else {
            var columns = [];
            question.columns.sort((a, b) => (a.position - b.position)).map((c, i) => {
                columns.push(<Draggable key={"columns-" + c.id} draggableId={"columns-" + c.id} index={i}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={
                                {
                                    border: snapshot.isDragging ? "solid 1px" : "",
                                    userSelect: "none",
                                    padding: 0,
                                    margin: `0`,
                                    background: snapshot.isDragging ? "#bbbbbb" : "",
                                    ...provided.draggableProps.style
                                }}>
                            <div className="flex flex-row my-2">
                                <div className='flex flex-row w-full q-input-wrapper'>
                                    <span>{this.getSVGIcon("sort", "inline h-4 w-4 move")}</span>
                                    <span>عنوان</span>
                                    <input type="text" defaultValue={c.caption} onChange={e => this.setColumnValue(i, e.target.value)} className={"w-full text-center focus:border-brand focus:ring-0 dark:focus:border-brand-dark dark:border-light-700 border-gray-300 p-0"} />
                                </div>
                                <span className='fill-current p-1 hand' onClick={e => this.removeColumn(i)} style={{ "background-color": "#f0f2f5", "border-radius": "0.25rem" }}>{this.getSVGIcon("trash", "inline h-4 w-4 mx-1")} </span>
                            </div>
                        </div>
                    )}
                </Draggable>);
            });

            res.push(<DragDropContext onDragEnd={this.onDragEndColumns}>
                <Droppable droppableId="droppableColumns">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {columns}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>);
        }
        res.push(<span className='hand mx-1 p-2 rounded bg-green-600 text-white transition-all duration-200 ease-in-out text-xs w-24 mt-2' onClick={e => this.addColumns()}>{this.getSVGIcon("plus", "inline h-4 w-4")}ستون جدید</span>);
        return res;
    }
    togglePreviewInPopup() {
        if (this.state.showPreviewInPopup) {
            this.setState({ showPreviewInPopup: false });
        }
        else {
            this.setState({ showPreviewInPopup: true });
        }
    }
    setRange(e, index) {
        var range = this.state.activeQuestionWindow.range;
        if (!range.includes(";")) range = ";";

        var s = range.split(";");
        s[index] = parseFloat(e.target.value);

        this.state.activeQuestionWindow.range = s[0] + ";" + s[1];
        this.setState({ activeQuestionWindow: this.state.activeQuestionWindow });
    }
    getRange(index) {
        var s = this.state.activeQuestionWindow.range.split(";");
        if (this.isBlank(s[index])) return "";
        else return parseFloat(s[index]);
    }
    renderQuestionPopup() {
        if (this.isNull(this.state.activeQuestionWindow)) return null;

        return <div className='questionnaire_q_popup' key={this.state.activeQuestionWindow.id} style={{ "position": "fixed", "width": "100%", "background-color": "rgba(0,0,0,.75)", "top": "0", "left": "0", "height": "100%", "z-index": "10000", "padding": "1rem" }}>
            <div style={{ "background-color": "white", "border-radius": ".5rem", "height": "100%" }}>
                <div className='flex flex-wrap' style={{ "height": "100%", "width": "100%" }}>
                    <div className='flex flex-col' style={{ "display": "flex", "align-items": "stretch", "flex-direction": "column", "width": (this.state.showPreviewInPopup ? "50%" : "100%"), "height": "100%", "border-radius": "0 0.5rem 0.5rem 0", "background-color": "#fff", "justify-content": "stretch", "border-left": "0.0625rem solid #f0f2f5" }}>
                        <div className='py-3 relative' style={{ "box-shadow": "inset 0 -0.125rem 0 0 #f0f2f5" }}>
                            <a className='hand mx-1 p-2 rounded bg-green-600  text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.saveQuestion()}> ذخیره </a>
                            <a className='hand mx-1 p-2 rounded bg-gray-400 text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.setState({ activeQuestionWindow: null })}> برگشت </a>
                            <a className={'hand mx-1 p-2 rounded text-white transition-all duration-200 ease-in-out text-xs absolute ' + (this.state.showPreviewInPopup ? "bg-blue-600" : "bg-gray-400")} style={{ "left": "0", "top": "7px" }} onClick={e => this.togglePreviewInPopup()}> پیشنمایش </a>
                        </div>
                        <div className='p-4' style={{ "overflow-y": "auto", "flex-grow": "1" }}>
                            {this.state.activeQuestionWindow.fieldType !== 7 &&
                                <div>
                                    <span className='font-bold'>متن سوال (اجباری)</span>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        language='fa'
                                        data={this.state.activeQuestionWindow.question}
                                        config={{
                                            toolbar: ['bold', 'italic', 'underline', 'link']
                                        }}
                                        onReady={editor => {
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.setQuestionValue('question', { target: { value: data } })
                                        }}
                                        onBlur={(event, editor) => {
                                        }}
                                        onFocus={(event, editor) => {
                                        }}
                                    />
                                </div>
                            }
                            {this.state.activeQuestionWindow.fieldType !== 7 ?
                                <div className='my-2'>
                                    <span className='font-bold'>راهنمای پاسخ به سوال</span>
                                    <input type="text" className="form-control" defaultValue={this.state.activeQuestionWindow.questionDesc} onChange={e => this.setQuestionValue('questionDesc', e)} />
                                </div>
                                :
                                <div className='my-2'>
                                    <span className='font-bold'>متن مورد نظر</span>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        language='fa'
                                        data={this.state.activeQuestionWindow.questionDesc}
                                        config={{
                                            toolbar: ['bold', 'italic', 'underline', 'link']
                                        }}
                                        onReady={editor => {
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.setQuestionValue('questionDesc', { target: { value: data } })
                                        }}
                                        onBlur={(event, editor) => {
                                        }}
                                        onFocus={(event, editor) => {
                                        }}
                                    />
                                </div>
                            }
                            <div className={'flex grid grid-cols-1 gap-4 px-2 ' + (this.state.activeQuestionWindow.fieldType !== 7 ? 'md:grid-cols-2' : 'md:grid-cols-1')} style={{ "background-color": "#f0f2f5","height":"auto" }}>
                                <div>
                                    {this.state.activeQuestionWindow.fieldType == 1 &&
                                        <div className='my-2'>
                                            <span className='font-bold'>فرمت دریافت اطلاعات</span>
                                            <select className="py-1 focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full" defaultValue={this.state.activeQuestionWindow.format} onChange={e => this.setQuestionValue('format', e)}>
                                                <option value="1">متن</option>
                                                <option value="2">عدد صحیح</option>
                                                <option value="3">عدد اعشاری</option>
                                                <option value="4">ایمیل</option>
                                                <option value="5">موبایل</option>
                                                <option value="6">وبسایت</option>
                                                <option value="7">کدملی</option>
                                                <option value="8">تاریخ شمسی</option>
                                                <option value="9">تاریخ میلادی</option>
                                                <option value="10">آی پی</option>
                                                {!this.isEmpty(this.state.data.myLegalPersons) && <option value="11">آپلود فایل</option>}
                                            </select>
                                        </div>
                                    }
                                    {(this.state.activeQuestionWindow.fieldType == 2 || this.state.activeQuestionWindow.fieldType == 4) &&
                                        <div className='my-2'>
                                            <span className='font-bold'>نحوه دریافت پاسخ</span>
                                            <select className="py-1 focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full" defaultValue={this.state.activeQuestionWindow.format} onChange={e => this.setQuestionValue('format', e)}>
                                                <option value="1">تک انتخابی</option>
                                                <option value="2">چند انتخابی</option>
                                                {this.state.activeQuestionWindow.fieldType != 4 && <option value="3">لیست کشویی</option>}
                                                <option value="4">متن</option>
                                                <option value="5">عدد</option>
                                                {this.state.activeQuestionWindow.fieldType != 4 && <option value="6">آواتار</option>}
                                            </select>
                                        </div>
                                    }
                                    {((this.state.activeQuestionWindow.fieldType == 1 && (this.state.activeQuestionWindow.format == 2 || this.state.activeQuestionWindow.format == 3)) ||
                                        ((this.state.activeQuestionWindow.fieldType == 2 || this.state.activeQuestionWindow.fieldType == 4) && (this.state.activeQuestionWindow.format == 5))) &&
                                        <div className='my-2'>
                                            <span className='font-bold'>محدوده قابل قبول</span>
                                            <div className='flex flex-row'>
                                                <div className='flex flex-col'>
                                                    <span>ابتدا</span>
                                                    <input type="number" onChange={e => this.setRange(e, 0)} defaultValue={this.getRange(0)} className='py-1 focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full' />
                                                </div>
                                                <div className='flex flex-col mr-2'>
                                                    <span>انتها</span>
                                                    <input type="number" onChange={e => this.setRange(e, 1)} defaultValue={this.getRange(1)} className='py-1 focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full' />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {((this.state.activeQuestionWindow.fieldType == 2 && (this.state.activeQuestionWindow.format == 2 || this.state.activeQuestionWindow.format == 3)) ||
                                        (this.state.activeQuestionWindow.fieldType == 4 && (this.state.activeQuestionWindow.format == 2))) &&
                                        <div className='my-2'>
                                            {this.state.activeQuestionWindow.fieldType == 2 && <span className='font-bold'>حداکثر تعداد پاسخ مجاز</span>}
                                            {this.state.activeQuestionWindow.fieldType == 4 && <span className='font-bold'>حداکثر تعداد پاسخ مجاز در هر ردیف</span>}
                                            <select className="py-1 focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full " defaultValue={this.state.activeQuestionWindow.maxSelect} onChange={e => this.setQuestionValue('maxSelect', e)}>
                                                <option value="0">بدون محدودیت</option>
                                                {this.state.activeQuestionWindow.fieldType == 2 && this.state.activeQuestionWindow.options.map((o, i) => <option value={i + 1}>{i + 1}</option>)}
                                                {this.state.activeQuestionWindow.fieldType == 4 && this.state.activeQuestionWindow.columns.sort((a, b) => (a.position - b.position)).map((o, i) => <option value={i + 1}>{i + 1}</option>)}
                                            </select>
                                        </div>
                                    }
                                    {((this.state.activeQuestionWindow.fieldType == 2 && (this.state.activeQuestionWindow.format == 1 || this.state.activeQuestionWindow.format == 2 || this.state.activeQuestionWindow.format == 3)) ||
                                        (this.state.activeQuestionWindow.fieldType == 4 && (this.state.activeQuestionWindow.format == 1 || this.state.activeQuestionWindow.format == 2))) &&
                                        <div className='my-2'>
                                            <input type="checkbox" defaultChecked={this.state.activeQuestionWindow.pointEnable === 1 ? true : false} onChange={e => this.setQuestionValue('pointEnable', e)} /> امتیاز (وزن دهی) به پاسخ ها
                                        </div>
                                    }
                                    {this.state.activeQuestionWindow.fieldType !== 7 && <p className='my-2'>
                                        <input type="checkbox" defaultChecked={this.state.activeQuestionWindow.required === 1 ? true : false} onChange={e => this.setQuestionValue('required', e)} /> پاسخ به این سوال اجباری است
                                    </p>
                                    }
                                    {this.state.activeQuestionWindow.fieldType !== 7 && <p className='my-2'>
                                        <input type="checkbox" defaultChecked={this.state.activeQuestionWindow.showNumber === 1 ? true : false} onChange={e => this.setQuestionValue('showNumber', e)} /> نمایش شماره سوال
                                    </p>
                                    }
                                </div>
                                <div>
                                    {<p>
                                        <Uploader
                                            className={this.isBlank(this.state.activeQuestionWindow.cover.s) ? "" : "hidden"}
                                            withPreview={false}
                                            withIcon={true}
                                            withLabel={false}
                                            buttonText='درج عکس'
                                            fileSizeError="حجم فایل انتخابی زیاد است"
                                            fileTypeError="فرمت فایل انتخابی نامعتبر است"
                                            onChange={this.onDropPic}
                                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.webp']}
                                            singleImage={true}
                                            maxFileSize={5242880}
                                            ref={r => this.inputFileRef = r}
                                        />
                                        {this.isBlank(this.state.activeQuestionWindow.cover.s) ?
                                            null
                                            :
                                            <div className='flex flex-col items-center'>
                                                <div className='text-center my-2'>
                                                    <img src={this.toImageUrl(this.state.activeQuestionWindow.cover,this.state.data.record.id)} className="mx-auto w-24"></img>
                                                    <a onClick={(e) => this.setQuestionValue('cover', { s: '', w: 0, h: 0 })} className='hand text-red-500 text-center mx-2'>حذف تصویر</a>
                                                    <a onClick={e => this.inputFileRef.triggerFileUpload()} className='hand text-green-700 text-center mx-2'>تغییر تصویر</a>
                                                </div>
                                                <div className='flex flex-row'>
                                                    <div className='flex flex-col'>
                                                        <label className='font-bold'>عرض تصویر</label>
                                                        <input type="number" min={100} max={2000} onChange={e => this.setQuestionValue('cover', { s: this.state.activeQuestionWindow.cover.s, w: e.target.value, h: this.state.activeQuestionWindow.cover.h })} defaultValue={this.state.activeQuestionWindow.cover.w} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                    </div>
                                                    <div className='flex flex-col mr-2'>
                                                        <label className='font-bold'>ارتفاع تصویر</label>
                                                        <input type="number" min={100} max={2000} onChange={e => this.setQuestionValue('cover', { s: this.state.activeQuestionWindow.cover.s, w: this.state.activeQuestionWindow.cover.w, h: e.target.value })} defaultValue={this.state.activeQuestionWindow.cover.h} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </p>
                                    }
                                </div>
                            </div>
                            {(this.state.activeQuestionWindow.fieldType === 2 || this.state.activeQuestionWindow.fieldType === 4) && <div className='flex flex-col my-2'>{this.renderOptionsMatrix()}</div>}
                            {(this.state.activeQuestionWindow.fieldType === 4) && <div className='flex flex-col my-2'>{this.renderColumnsMatrix()}</div>}
                        </div>
                    </div>
                    {this.state.showPreviewInPopup &&
                        <div style={{ "width": "50%" }}>
                            <div style={{ "height": "100%", "font-size": "1rem", "line-height": "2rem", "backgroundColor": this.state.data.record.style.backgroundColor }}>
                                {this.renderQuestionBox(this.state.activeQuestionWindow, true, this.state.data.record.style)}
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
    setTempRecordValue(f, v) {
        this.state.tempRecord[f] = v;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    renderStartPagePopop() {

        if (this.isNull(this.state.startPage)) return null;
        if (this.state.startPage != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#000000bf", "top": "0", "left": "0", "height": "100%", "z-index": "10000", "padding": "1rem" }}>
            <div style={{ "height": "100%", "background-color": "white", "border-radius": "0.5rem" }}>
                <div style={{ "background-color": "white", "border-radius": "0.5rem", "height": "100%" }}>
                    <div className="flex flex-wrap" style={{ "height": "100%", "width": "100%" }}>
                        <div className="flex flex-col" style={{ "display": "flex", "align-items": "stretch", "flex-direction": "column", "width": "50%", "height": "100%", "border-radius": "0px 0.5rem 0.5rem 0px", "background-color": "rgb(255, 255, 255)", "justify-content": "stretch", "border-left": "0.0625rem solid rgb(240, 242, 245)" }}>
                            <div className='py-3 relative' style={{ "box-shadow": "inset 0 -0.125rem 0 0 #f0f2f5" }}>
                                <a className='hand mx-1 p-2 rounded bg-green-600  text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.save()}> ذخیره </a>
                                <a className='hand mx-1 p-2 rounded bg-gray-400 text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.setState({ startPage: null })}> برگشت </a>
                                <a className={'hand mx-1 p-2 rounded text-white transition-all duration-200 ease-in-out text-xs absolute ' + (this.state.showPreviewInPopup ? "bg-blue-600" : "bg-gray-400")} style={{ "left": "0", "top": "7px" }} onClick={e => this.togglePreviewInPopup()}> پیشنمایش </a>
                            </div>
                            <div className='p-4' style={{ "overflow-y": "auto", "flex-grow": "1" }}>
                                <p className='my-2'>
                                    <input type="checkbox" defaultChecked={this.state.tempRecord.startPageDisplay === 1 ? true : false} onChange={e => this.setTempRecordValue('startPageDisplay', (e.target.checked ? 1 : 0))} /> صفحه خوش آمدگویی نمایش داده شود؟
                                </p>
                                <p className='my-2'>
                                    <label className='font-bold'>عنوان</label>
                                    <input type="text" defaultValue={this.state.tempRecord.startPageCaption} onChange={e => this.setTempRecordValue('startPageCaption', e.target.value)} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                </p>
                                <p className='my-2'>
                                    <label className='font-bold'>متن</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        language='fa'
                                        data={this.state.tempRecord.startPageDescription}
                                        config={{
                                            toolbar: ['bold', 'italic', 'underline', 'link']
                                        }}
                                        onReady={editor => {
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.setTempRecordValue('startPageDescription', data)
                                        }}
                                        onBlur={(event, editor) => {
                                        }}
                                        onFocus={(event, editor) => {
                                        }}
                                    />
                                </p>
                                <div className='flex grid grid-cols-1 gap-4 px-2 md:grid-cols-2' style={{ "backgroundColor": "#f0f2f5","height":"auto" }}>
                                    <div>
                                        {!this.isBlank(this.state.tempRecord.startPageCover.s) &&
                                            <div className='flex flex-row'>
                                                <div className='flex flex-col'>
                                                    <label className='font-bold'>عرض تصویر</label>
                                                    <input type="number" min={100} max={2000} onChange={e => this.setTempRecordValue('startPageCover', { s: this.state.tempRecord.startPageCover.s, w: e.target.value, h: this.state.tempRecord.startPageCover.h })} defaultValue={this.state.tempRecord.startPageCover.w} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                </div>
                                                <div className='flex flex-col mr-2'>
                                                    <label className='font-bold'>ارتفاع تصویر</label>
                                                    <input type="number" min={100} max={2000} onChange={e => this.setTempRecordValue('startPageCover', { s: this.state.tempRecord.startPageCover.s, w: this.state.tempRecord.startPageCover.w, h: e.target.value })} defaultValue={this.state.tempRecord.startPageCover.h} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        <Uploader
                                            className={this.isBlank(this.state.tempRecord.startPageCover.s) ? "" : "hidden"}
                                            withPreview={false}
                                            withIcon={true}
                                            withLabel={false}
                                            buttonText='درج عکس'
                                            fileSizeError="حجم فایل انتخابی زیاد است"
                                            fileTypeError="فرمت فایل انتخابی نامعتبر است"
                                            onChange={this.onDropPic2}
                                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.webp']}
                                            singleImage={true}
                                            maxFileSize={5242880}
                                            ref={r => this.inputFileRef2 = r}
                                        />
                                        {this.isBlank(this.state.tempRecord.startPageCover.s) ?
                                            null
                                            :
                                            <div className='text-center my-2'>
                                                <img src={this.toImageUrl(this.state.tempRecord.startPageCover, this.state.data.record.id)} className="mx-auto w-24"></img>
                                                <a onClick={(e) => this.setTempRecordValue('startPageCover', { s: '', w: 0, h: 0 })} className='hand text-red-500 text-center mx-2'>حذف تصویر</a>
                                                <a onClick={e => this.inputFileRef2.triggerFileUpload()} className='hand text-green-700 text-center mx-2'>تغییر تصویر</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.showPreviewInPopup && <div style={{ "width": "50%" }}>
                            <div style={{ "height": "100%", "font-size": "1rem", "line-height": "2rem", "backgroundColor": this.state.data.record.style.backgroundColor }}>
                                {this.renderFirstPage(this.state.tempRecord, true)}
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
    renderFinishPagePopop() {

        if (this.isNull(this.state.finishPage)) return null;
        if (this.state.finishPage != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#000000bf", "top": "0", "left": "0", "height": "100%", "z-index": "10000", "padding": "1rem" }}>
            <div style={{ "height": "100%", "background-color": "white", "border-radius": "0.5rem" }}>
                <div style={{ "background-color": "white", "border-radius": "0.5rem", "height": "100%" }}>
                    <div className="flex flex-wrap" style={{ "height": "100%", "width": "100%" }}>
                        <div className="flex flex-col" style={{ "display": "flex", "align-items": "stretch", "flex-direction": "column", "width": "50%", "height": "100%", "border-radius": "0px 0.5rem 0.5rem 0px", "background-color": "rgb(255, 255, 255)", "justify-content": "stretch", "border-left": "0.0625rem solid rgb(240, 242, 245)" }}>
                            <div className='py-3 relative' style={{ "box-shadow": "inset 0 -0.125rem 0 0 #f0f2f5" }}>
                                <a className='hand mx-1 p-2 rounded bg-green-600  text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.save()}> ذخیره </a>
                                <a className='hand mx-1 p-2 rounded bg-gray-400 text-white transition-all duration-200 ease-in-out text-xs' onClick={e => this.setState({ finishPage: null })}> برگشت </a>
                                <a className={'hand mx-1 p-2 rounded text-white transition-all duration-200 ease-in-out text-xs absolute ' + (this.state.showPreviewInPopup ? "bg-blue-600" : "bg-gray-400")} style={{ "left": "0", "top": "7px" }} onClick={e => this.togglePreviewInPopup()}> پیشنمایش </a>
                            </div>
                            <div className='p-4' style={{ "overflow-y": "auto", "flex-grow": "1" }}>
                                <p className='my-2'>
                                    <input type="checkbox" defaultChecked={this.state.tempRecord.finishPageDisplay === 1 ? true : false} onChange={e => this.setTempRecordValue('finishPageDisplay', (e.target.checked ? 1 : 0))} /> صفحه تشکر نمایش داده شود؟
                                </p>
                                <p className='my-2'>
                                    <input type="checkbox" defaultChecked={this.state.tempRecord.displayResualt === 1 ? true : false} onChange={e => this.setTempRecordValue('displayResualt', (e.target.checked ? 1 : 0))} /> پیش نمایش پاسخ های وارد شده قبل از ارسال نهایی نمایش داده شود؟
                                </p>
                                <p className='my-2'>
                                    <label className='font-bold'>عنوان</label>
                                    <input type="text" defaultValue={this.state.tempRecord.finishPageCaption} onChange={e => this.setTempRecordValue('finishPageCaption', e.target.value)} className="form-control" />
                                </p>
                                <p className='my-2'>
                                    <label className='font-bold'>متن</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        language='fa'
                                        data={this.state.tempRecord.finishPageDescription}
                                        config={{
                                            toolbar: ['bold', 'italic', 'underline', 'link']
                                        }}
                                        onReady={editor => {
                                        }}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.setTempRecordValue('finishPageDescription', data)
                                        }}
                                        onBlur={(event, editor) => {
                                        }}
                                        onFocus={(event, editor) => {
                                        }}
                                    />
                                </p>
                                <div className='flex grid grid-cols-1 gap-4 px-2 md:grid-cols-2' style={{ "backgroundColor": "#f0f2f5","height":"auto" }}>
                                    <div>
                                        {!this.isBlank(this.state.tempRecord.finishPageCover.s) &&
                                            <div className='flex flex-row'>
                                                <div className='flex flex-col'>
                                                    <label className='font-bold'>عرض تصویر</label>
                                                    <input type="number" min={100} max={2000} onChange={e => this.setTempRecordValue('finishPageCover', { s: this.state.tempRecord.finishPageCover.s, w: e.target.value, h: this.state.tempRecord.finishPageCover.h })} defaultValue={this.state.tempRecord.finishPageCover.w} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                </div>
                                                <div className='flex flex-col mr-2'>
                                                    <label className='font-bold'>ارتفاع تصویر</label>
                                                    <input type="number" min={100} max={2000} onChange={e => this.setTempRecordValue('finishPageCover', { s: this.state.tempRecord.finishPageCover.s, w: this.state.tempRecord.finishPageCover.w, h: e.target.value })} defaultValue={this.state.tempRecord.finishPageCover.h} className="focus:border-brand dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-1" />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div>
                                        <Uploader
                                            className={this.isBlank(this.state.tempRecord.finishPageCover.s) ? "" : "hidden"}
                                            withPreview={false}
                                            withIcon={true}
                                            withLabel={false}
                                            buttonText='درج عکس'
                                            fileSizeError="حجم فایل انتخابی زیاد است"
                                            fileTypeError="فرمت فایل انتخابی نامعتبر است"
                                            onChange={this.onDropPic3}
                                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg', '.webp']}
                                            singleImage={true}
                                            maxFileSize={5242880}
                                            ref={r => this.inputFileRef2 = r}
                                        />
                                        {this.isBlank(this.state.tempRecord.finishPageCover.s) ?
                                            null
                                            :
                                            <div className='text-center my-2'>
                                                <img src={this.toImageUrl(this.state.tempRecord.finishPageCover, this.state.data.record.id)} className="mx-auto w-24"></img>
                                                <a onClick={(e) => this.setTempRecordValue('finishPageCover', { s: '', w: 0, h: 0 })} className='hand text-red-500 text-center mx-2'>حذف تصویر</a>
                                                <a onClick={e => this.inputFileRef2.triggerFileUpload()} className='hand text-green-700 text-center mx-2'>تغییر تصویر</a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.showPreviewInPopup && <div style={{ "width": "50%" }}>
                            <div style={{ "height": "100%", "font-size": "1rem", "line-height": "2rem", "backgroundColor": this.state.data.record.style.backgroundColor }}>
                                {this.renderLastPage(this.state.tempRecord)}
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    }
    changePayPrize(e) {
        this.state.tempRecord.payPrize = (e.target.checked ? 1 : 0);
        this.setState({ tempRecord: this.state.tempRecord });
    }
    renderPrizePagePopop() {

        if (this.isNull(this.state.prizePage)) return null;
        if (this.state.prizePage != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "80%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <p className='mt-2 mb-8'>
                    <input type="checkbox" defaultChecked={this.state.tempRecord.payPrize === 1 ? true : false} onChange={e => this.changePayPrize(e)} /> آیا میخواهید به پاسخ دهندگان پاداش و هدیه دهید؟
                </p>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 relative my-2 p-4'>
                    {this.state.tempRecord.payPrize === 0 &&
                        <div style={{ "position": "absolute", "top": "0", "left": "0", "background-color": "#73737373", "height": "100%", "width": "100%", "cursor": "not-allowed", "border-radius": "4px" }}></div>
                    }
                    <div>
                        <div className='border p-2'>
                            <label className='font-bold'>میزان اعتبار هدیه برای هر نفر پاسخ دهنده به این پرسشنامه</label>
                            <input type="text" defaultValue={this.state.tempRecord.creditToPrize} onChange={e => this.state.tempRecord.creditToPrize = e.target.value} style={{ "width": "100px" }} className="form-control" />
                        </div>
                    </div>
                    <div>
                        <div className='border p-2'>
                            <label>اعتبار فعلی پرسشنامه: {this.money(this.state.tempRecord.credit)}</label>
                            <p>جهت افزایش اعتبار پرسشنامه بایستی از اعتبارهای حساب کاربری خود به این پرسشنامه انتقال دهید</p>
                        </div>
                    </div>
                </div>
                <div className='mt-8 text-center'>
                    <a className='hand btn bg-green-600 text-white transition-all duration-200 ease-in-out' onClick={e => this.savePrizeConfig()}> ذخیره </a>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ prizePage: null })}> بستن </a>
                </div>
            </div>
        </div>
    }
    renderEmailPagePopop() {

        if (this.isNull(this.state.emailPage)) return null;
        if (this.state.emailPage != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "80%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 relative my-2 p-4'>
                    <div>
                        <div className='border p-2'>
                            <p className='font-bold mb-4'><input type="checkbox" defaultChecked={this.state.tempRecord.notifications.clientEmail == 1 ? true : false} onChange={e => this.state.tempRecord.notifications.clientEmail = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" /> ارسال ایمیل به پاسخ دهنده پرسشنامه</p>
                            <p className='text-color-base dark:text-color-base-dark font-medium'>عنوان ایمیل</p>
                            <input type="text" defaultValue={this.state.tempRecord.notifications.clientEmailSubject} onChange={e => this.state.tempRecord.notifications.clientEmailSubject = e.target.value} className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-2 mb-4" />
                            <p className='text-color-base dark:text-color-base-dark font-medium'>متن ایمیل</p>
                            <CKEditor
                                editor={ClassicEditor}
                                language='fa'
                                data={this.state.tempRecord.notifications.clientEmailContent}
                                config={{
                                    toolbar: ['bold', 'italic', 'underline', 'link']
                                }}
                                onReady={editor => {
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.state.tempRecord.notifications.clientEmailContent = data;
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <div className='border p-2'>
                            <p className='font-bold mb-4'><input type="checkbox" defaultChecked={this.state.tempRecord.notifications.designerEmail == 1 ? true : false} onChange={e => this.state.tempRecord.notifications.designerEmail = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" /> ارسال ایمیل به طراح پرسشنامه</p>
                            <p className='text-color-base dark:text-color-base-dark font-medium'>عنوان ایمیل</p>
                            <input type="text" defaultValue={this.state.tempRecord.notifications.designerEmailSubject} onChange={e => this.state.tempRecord.notifications.designerEmailSubject = e.target.value} className="focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 w-full py-2 mb-4" />
                            <p className='text-color-base dark:text-color-base-dark font-medium'>متن ایمیل</p>
                            <CKEditor
                                editor={ClassicEditor}
                                language='fa'
                                data={this.state.tempRecord.notifications.designerEmailContent}
                                config={{
                                    toolbar: ['bold', 'italic', 'underline', 'link']
                                }}
                                onReady={editor => {
                                }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    this.state.tempRecord.notifications.designerEmailContent = data;
                                }}
                                onBlur={(event, editor) => {
                                }}
                                onFocus={(event, editor) => {
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className='mt-8 text-center'>
                    <a className='hand btn bg-green-600 text-white transition-all duration-200 ease-in-out' onClick={e => this.saveEmailConfig()}> ذخیره </a>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ emailPage: null })}> بستن </a>
                </div>
            </div>
        </div>
    }
    renderConditions() {
        var res = [];

        this.state.conditions.conditions.map((cond, index) => {
            res.push(<div key={cond.id} className="flex flex-row gap-4 my-4">
                <select defaultValue={cond.type} onChange={e => this.setConditionValue(cond, "type", e.target.value)} className="form-control">
                    <option value="1">امتیاز کسب شده سوال قبلی</option>
                    <option value="2">مجموع امتیازات کسب شده تا این سوال</option>
                    <option value="3">نوع کاربر پاسخ دهنده</option>
                </select>
                {(cond.type == 1 || cond.type == 2) && <select defaultValue={cond.op} onChange={e => this.setConditionValue(cond, "op", e.target.value)} className="form-control">
                    <option value="1">مساوی</option>
                    <option value="2">بزرگتر و مساوی</option>
                    <option value="3">کوچکتر و مساوی</option>
                    <option value="4">بزرگتر</option>
                    <option value="5">کوچکتر</option>
                </select>}
                {(cond.type == 3) && <select defaultValue={cond.op} onChange={e => this.setConditionValue(cond, "op", e.target.value)} className="form-control">
                    <option value="1">فقط اعضا</option>
                    <option value="2">فقط غیر اعضا</option>
                </select>}
                {(cond.type == 1 || cond.type == 2) && <input defaultValue={cond.value} onChange={e => this.setConditionValue(cond, "value", e.target.value)} placeholder={"امتیاز"} min={0} type="number" className="form-control" />}
                <span className='text-red-200 py-2 px-2 rounded-full rtl:mr-4 ltr:ml-4 hand' onClick={e => this.removeCondition(cond)}>{this.getSVGIcon("trash", "inline h-4 w-4 mx-1")} </span>
            </div>);
        });
        return res;
    }
    renderConditionsPopup() {
        if (this.isNull(this.state.conditions)) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "80%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <p className='mt-2 mb-8'>
                    شرطهایی که بایستی محقق شوند تا این سوال نمایش داده شوند را وارد نمایید. توجه داشته باشید که چنانچه شرطی وارد ننمایید به صورت پیش فرض سوال نمایش داده خواهد شد
                </p>
                <span className='bg-green-200 py-2 px-2 rounded-full rtl:ml-2 ltr:mr-2 hand' style={{"display": "inline-block"}} onClick={e => this.addCondition()}>{this.getSVGIcon("plus", "inline h-4 w-4")}افزودن شرط جدید به این سوال</span>
                {this.renderConditions()}
                <div className='mt-8 text-center'>
                    <a className='hand btn bg-green-600 text-white transition-all duration-200 ease-in-out' onClick={e => this.saveCondition()}> ذخیره </a>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ conditions: null })}> بستن </a>
                </div>
            </div>
        </div>
    }
    setBackground(e) {
        this.state.tempRecord.style.backgroundColor = e.hex;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    setColor(e) {
        this.state.tempRecord.style.questionColor = e.hex;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    setAnswerColor(e) {
        this.state.tempRecord.style.answerColor = e.hex;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    setFocusColor(e) {
        this.state.tempRecord.style.focusColor = e.hex;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    getButtonColor(rgb) {
        const brightness = ((rgb.r * 299) + (rgb.g * 587) + (rgb.b * 114)) / 1000;
        if (brightness > 155)
            return "#000000";
        else
            return "#ffffff";
    }
    setButtonColor(e) {
        this.state.tempRecord.style.buttonBackgroundColor = e.hex;
        this.state.tempRecord.style.buttonColor = this.getButtonColor(e.rgb);
        this.setState({ tempRecord: this.state.tempRecord });
    }
    openColorPopup(n) {
        if (n === this.state.colorPopup)
            this.setState({ colorPopup: 0 });
        else
            this.setState({ colorPopup: n });
    }
    changeTemplate(template) {
        this.state.tempRecord.style = template;
        this.setState({ tempRecord: this.state.tempRecord });
    }
    getColorTemplates() {
        //id,back,question,ansver,focos,button
        var templates = [
            [1, "#f1f1f1", "#333333", "#333333", "#118eb7", "#118eb7"],
            [2, "#fed83d", "#4a4a4a", "#4a4a4a", "#927919", "#4a4a4a"],
            [3, "#c5e0dc", "#de7b62", "#de7b62", "#f19078", "#de7b62"],
            [4, "#efefef", "#e82800", "#e82800", "#ff4141", "#e82800"],
            [5, "#f5fdff", "#f15976", "#f15976", "#67cae0", "#67cae0"],
            [6, "#285975", "#fbf7bc", "#fbf7bc", "#fffdd5", "#fbf7bc"],
            [7, "#ffffff", "#677584", "#677584", "#7f91a4", "#677584"],
            [8, "#fff3e8", "#f27154", "#f27154", "#ff7d5f", "#f27154"],
            [9, "#002a63", "#ffffff", "#ffffff", "#f26321", "#f26321"],
            [10, "#74c19d", "#ffece3", "#ffece3", "#ffc1a2", "#ffc1a2"],
            [11, "#2c2d40", "#ffffff", "#ffffff", "#4a90e2", "#4a90e2"],
            [12, "#eaf2fc", "#1e6dc8", "#1e6dc8", "#60a3f6", "#1e6dc8"]
        ];
        var list = [];
        templates.forEach(t => {
            list.push({
                templateId: t[0],
                backgroundColor: t[1],
                questionColor: t[2],
                answerColor: t[3],
                focusColor: t[4],
                buttonBackgroundColor: t[5],
                buttonColor: this.getButtonColor(this.hexToRgb(t[5])),
            })
        });
        return list;
    }
    getFlowChartNodes() {
        var nodes = [];
        nodes.push({
            type: "start",
            title: "شروع پرسشنامه",
            x: 150,
            y: 10,
            id: 1,
        });
        this.state.data.record.questions.forEach((question, index) => {
            nodes.push({
                x: 150,
                y: (100 * (index + 1)),
                id: question.id,
                title: this.htmlToString(question.question),
                type: "operation",
            });
            if (!this.isEmpty(question.conditions)) {
                question.conditions.forEach((cond, cond_index) => {
                    nodes.push({
                        x: (350 * (cond_index + 1)),
                        y: (100 * (index + 1)),
                        id: cond.id,
                        title: () => {
                            if (cond.type == 1) return "امتیاز کسب شده سوال قبلی";
                            if (cond.type == 2) return "مجموع امتیازات کسب شده تا این سوال";
                            if (cond.type == 3) return "نوع کاربر پاسخ دهنده";
                            return "شرط"
                        },
                        type: "decision",
                    });
                })
            }
        })
        nodes.push({
            type: "end",
            title: "انتهای پرسشنامه",
            x: 150,
            y: 500,
            id: 2,
        });
        return nodes;
    }
    getFlowChartConnections() {
        if (this.isEmpty(this.state.data.record.questions)) return [];

        var connections = [];
        connections.push({
            source: { id: 1, position: "bottom" },
            destination: { id: this.state.data.record.questions[0].id, position: "top" },
            type: "success",
        });

        this.state.data.record.questions.forEach((question, index) => {

            var destination = 2;
            if (index != this.state.data.record.questions.length - 1) destination = this.state.data.record.questions[index + 1].id;

            if (!this.isEmpty(question.conditions)) {
                question.conditions.forEach((cond, cond_index) => {
                    connections.push({
                        source: { id: question.id, position: "right" },
                        destination: { id: cond.id, position: "left" },
                        type: "success",
                    });
                    connections.push({
                        source: { id: cond.id, position: "bottom" },
                        destination: { id: destination, position: "right" },
                        type: "success",
                    });

                    var destination2 = 2;
                    if (index != this.state.data.record.questions.length - 2) destination2 = this.state.data.record.questions[index + 2].id;

                    connections.push({
                        source: { id: cond.id, position: "right" },
                        destination: { id: destination2, position: "right" },
                        type: "fail",
                    });
                });
            }
            else {
                connections.push({
                    source: { id: question.id, position: "bottom" },
                    destination: { id: destination, position: "top" },
                    type: "success",
                });
            }
        });
        return connections;
    }
    renderFlowChartPopop() {

        if (this.isNull(this.state.flowchart)) return null;
        if (this.state.flowchart != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "92%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <div className='felx flex-wrap mb-4'>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out absolute' style={{ "left": "30px", "top": "15px" }} onClick={e => this.setState({ flowchart: null })}> بستن </a>
                </div>
                <div className='flex flex-col border'>
                    <div className='flex flex-row mt-4'>
                        <Flowchart
                            readonly={true}
                            style={{ width: "100%", height: 600 }}
                            nodes={this.getFlowChartNodes()}
                            connections={this.getFlowChartConnections()}
                        />
                    </div>
                </div>
            </div>
        </div>
    }
    renderSettingsPopop() {

        if (this.isNull(this.state.settings)) return null;
        if (this.state.settings != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            {this.state.colorPopup > 0 && <div onClick={e => this.setState({ colorPopup: 0 })} style={{ "z-index": "1", "position": "absolute", "top": 0, "left": 0, "width": "100%", "height": "100%" }}></div>}
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "92%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <div className='felx flex-wrap mb-4'>
                    <a className={'hand rounded border-gray-200 pb-2 ' + (this.state.settingActiveTab == 1 ? "border-b font-bold" : "")} onClick={e => this.setState({ settingActiveTab: 1 })}> تنظیمات پرسشنامه </a>
                    <a className={'hand rounded border-gray-200 mx-2 pb-2 ' + (this.state.settingActiveTab == 2 ? "border-b font-bold" : "")} onClick={e => this.setState({ settingActiveTab: 2 })}> قالب ظاهری پرسشنامه </a>
                    <a className={'hand rounded border-gray-200 mx-2 pb-2 ' + (this.state.settingActiveTab == 3 ? "border-b font-bold" : "")} onClick={e => this.setState({ settingActiveTab: 3 })}> کاربران </a>
                    <a className='hand btn bg-green-600 text-white transition-all duration-200 ease-in-out absolute' style={{ "left": "100px", "top": "15px" }} onClick={e => this.save()}> ذخیره </a>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out absolute' style={{ "left": "30px", "top": "15px" }} onClick={e => this.setState({ settings: null })}> بستن </a>
                </div>
                {this.state.settingActiveTab == 1 &&
                    <div className='flex flex-col border pt-2'>
                        <div className='flex flex-row'>
                            <p className='mx-2'>
                                <input type="checkbox" defaultChecked={this.state.tempRecord.nextButton == 1 ? true : false} onChange={e => this.state.tempRecord.nextButton = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" />
                                <label className='font-bold'>نمایش دکمه بعدی</label>
                            </p>
                            <p className='mx-2'>
                                <input type="checkbox" defaultChecked={this.state.tempRecord.nextButton == 1 ? true : false} onChange={e => this.state.tempRecord.nextButton = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" />
                                <label className='font-bold'>نمایش دکمه قبلی</label>
                            </p>
                            <p className='mx-2'>
                                <input type="checkbox" defaultChecked={this.state.tempRecord.showQuestionCount == 1 ? true : false} onChange={e => this.state.tempRecord.showQuestionCount = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" />
                                <label className='font-bold'>نمایش تعداد سوالات</label>

                            </p>
                            <p className='mx-2'>
                                <input type="checkbox" defaultChecked={this.state.tempRecord.titleDisplay == 1 ? true : false} onChange={e => this.state.tempRecord.titleDisplay = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" />
                                <label className='font-bold'>نمایش عنوان پرسشنامه</label>
                            </p>
                        </div>
                        <p className='mx-2'>
                            <label className='font-bold'>عنوان پرسشنامه</label>
                            <input type="text" defaultValue={this.state.tempRecord.title} onChange={e => this.state.tempRecord.title = e.target.value} className="form-control" />
                        </p>
                        <div className='flex flex-row mt-2 p-2'>
                            <p className='mx-2'>
                                <label className='font-bold'>عنوان دکمه شروع</label>
                                <input type="text" defaultValue={this.state.tempRecord.configs.startButtonCaption} onChange={e => this.state.tempRecord.configs.startButtonCaption = e.target.value} className="form-control" />
                            </p>
                            <p className='mx-2'>
                                <label className='font-bold'>نحوه نمایش سوالات</label>
                                <select defaultValue={this.state.tempRecord.displayMode} onChange={e => this.state.tempRecord.displayMode = e.target.value} className="form-control">
                                    <option value="1">هر سوال در یک صفحه</option>
                                    <option value="2">همه سوالات در یک صفحه</option>
                                </select>
                            </p>
                            <p className='mx-2'>
                                <label className='font-bold'>دسته بندی</label>
                                <select defaultValue={this.state.tempRecord.category} onChange={e => this.state.tempRecord.category = e.target.value} className="form-control">
                                    <option value="">انتخاب کنید</option>
                                    <option value="1">پژوهش های دانشگاهی</option>
                                    <option value="2">تحقیقات بازار</option>
                                    <option value="3">آزمونهای منابع انسانی و تستهای روانشناسی</option>
                                    <option value="4">نظرسنجی مشتریان</option>
                                    <option value="5">فرم سازمانی</option>
                                </select>
                            </p>
                            <p className='mx-2'>
                                <label className='font-bold'>دسترسی</label>
                                <select defaultValue={this.state.tempRecord.type} onChange={e => this.state.tempRecord.type = e.target.value} className="form-control">
                                    <option value="1">عمومی</option>
                                    <option value="2">مختص اعضای سایت</option>
                                </select>
                            </p>
                            <p className='mx-2'>
                                <label className='font-bold'>زبان</label>
                                <select defaultValue={this.state.tempRecord.lang} onChange={e => this.state.tempRecord.lang = e.target.value} className="form-control">
                                    <option value="1">فارسی</option>
                                    <option value="2">انگلیسی</option>
                                </select>
                            </p>
                        </div>
                    </div>
                }
                {this.state.settingActiveTab == 2 &&
                    <div className='flex flex-col border pb-2'>
                        <p className='p-2 font-bold text-xl'>شخصی سازی قالب</p>
                        <div className='flex flex-row mb-4'>
                            <p className='mt-2 mx-2 border p-2'>
                                <label className='font-bold hand' onClick={e => this.openColorPopup(1)}><span style={{ "backgroundColor": this.state.tempRecord.style.backgroundColor, "width": "10px", "height": "10px", "display": "inline-block", "border-radius": "100%", "border": "1px solid rgba(128, 128, 128, 0.41)" }}></span> رنگ زمینه</label>
                                <div style={{ "z-index": "2" }} className={this.state.colorPopup == 1 ? 'absolute' : 'hidden'}>
                                    <SketchPicker
                                        colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#000000", "#666666", "#B3B3B3", "#FFFFFF", "#4D4D4D", "#999999"]}
                                        color={this.state.tempRecord.style.backgroundColor}
                                        onChangeComplete={e => this.setBackground(e)}
                                    />
                                </div>
                            </p>
                            <p className='mt-2 mx-2 border p-2'>
                                <label className='font-bold hand' onClick={e => this.openColorPopup(2)}><span style={{ "backgroundColor": this.state.tempRecord.style.questionColor, "width": "10px", "height": "10px", "display": "inline-block", "border-radius": "100%", "border": "1px solid rgba(128, 128, 128, 0.41)" }}></span> رنگ نوشتار</label>
                                <div style={{ "z-index": "2" }} className={this.state.colorPopup == 2 ? 'absolute' : 'hidden'}>
                                    <SketchPicker
                                        colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#000000", "#666666", "#B3B3B3", "#FFFFFF", "#4D4D4D", "#999999"]}
                                        color={this.state.tempRecord.style.questionColor}
                                        onChangeComplete={e => this.setColor(e)}
                                    />
                                </div>
                            </p>
                            <p className='mt-2 mx-2 border p-2'>
                                <label className='font-bold hand' onClick={e => this.openColorPopup(3)}><span style={{ "backgroundColor": this.state.tempRecord.style.answerColor, "width": "10px", "height": "10px", "display": "inline-block", "border-radius": "100%", "border": "1px solid rgba(128, 128, 128, 0.41)" }}></span> رنگ پاسخ</label>
                                <div style={{ "z-index": "2" }} className={this.state.colorPopup == 3 ? 'absolute' : 'hidden'}>
                                    <SketchPicker
                                        colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#000000", "#666666", "#B3B3B3", "#FFFFFF", "#4D4D4D", "#999999"]}
                                        color={this.state.tempRecord.style.answerColor}
                                        onChangeComplete={e => this.setAnswerColor(e)}
                                    />
                                </div>
                            </p>
                            <p className='mt-2 mx-2 border p-2'>
                                <label className='font-bold hand' onClick={e => this.openColorPopup(4)}><span style={{ "backgroundColor": this.state.tempRecord.style.focusColor, "width": "10px", "height": "10px", "display": "inline-block", "border-radius": "100%", "border": "1px solid rgba(128, 128, 128, 0.41)" }}></span> رنگ فوکوس</label>
                                <div style={{ "z-index": "2" }} className={this.state.colorPopup == 4 ? 'absolute' : 'hidden'}>
                                    <SketchPicker
                                        colors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#000000", "#666666", "#B3B3B3", "#FFFFFF", "#4D4D4D", "#999999"]}
                                        color={this.state.tempRecord.style.focusColor}
                                        onChangeComplete={e => this.setFocusColor(e)}
                                    />
                                </div>
                            </p>
                            <p className='mt-2 mx-2 border p-2'>
                                <label className='font-bold hand' onClick={e => this.openColorPopup(5)}><span style={{ "backgroundColor": this.state.tempRecord.style.buttonBackgroundColor, "width": "10px", "height": "10px", "display": "inline-block", "border-radius": "100%", "border": "1px solid rgba(128, 128, 128, 0.41)" }}></span> رنگ دکمه</label>
                                <div style={{ "z-index": "2" }} className={this.state.colorPopup == 5 ? 'absolute' : 'hidden'}>
                                    <SketchPicker
                                        presetColors={["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b", "#000000", "#666666", "#B3B3B3", "#FFFFFF", "#4D4D4D", "#999999"]}
                                        color={this.state.tempRecord.style.buttonBackgroundColor}
                                        onChangeComplete={e => this.setButtonColor(e)}
                                    />
                                </div>
                            </p>
                        </div>
                        <p className="p-2 font-bold text-xl">انتخاب قالب آماده</p>
                        <div className='grid grid-cols-4 gap-4'>
                            {this.getColorTemplates().map(template =>
                                <div className='q-template-item mt-2 mx-2 border p-2 flex flex-col' style={{ "backgroundColor": template.backgroundColor }}>
                                    <p style={{ "color": template.questionColor }}>متن سوال</p>
                                    <input type="text" style={{ "color": template.answerColor, "borderColor": template.focusColor }} value="متن پاسخ" className='mt-2 focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 bg-transparent border-gray-300 mx-2'></input>
                                    <button style={{ "backgroundColor": template.buttonBackgroundColor, "color": template.buttonColor }} className="mt-2 hand bg-brand dark:bg-brand-dark text-white px-4 py-2 rounded hover:bg-brand/90 dark:hover:bg-brand-dark/90 duration-200 ease-in-out">دکمه</button>
                                    <div className={'q-template-item-picker ' + (this.state.tempRecord.style.templateId == template.templateId ? "selected" : "")}>
                                        {this.state.tempRecord.style.templateId == template.templateId ?
                                            <a>انتخاب شده</a>
                                            :
                                            <a className='hand' onClick={e => this.changeTemplate(template)}>انتخاب قالب</a>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {this.state.settingActiveTab == 3 &&
                    <div className='flex flex-col border p-2'>
                        <p>اگر قصد دارید تا افراد دیگری هم به این پرسشنامه دسترسی مشاهده نتایج و یا ویرایش پرسشنامه را داشته باشند از طریق فرم زیر میتوانید دعوت  نامه پیوستن به این پرسشنامه را ارسال نمایید</p>
                        <div className="flex flex-row mt-4 mb-4">
                            <label className='font-bold'>شماره موبایل</label>
                            <input type="text" defaultValue={this.state.inviteMobileNo} onChange={e => this.state.inviteMobileNo = e.target.value} className="mb-2 focus:border-brand focus:ring-0 focus:border-b-2 dark:focus:border-brand-dark dark:border-light-700 border-t-0 border-r-0 border-l-0 bg-transparent border-gray-300 py-2 " />
                            <p className='mx-2 p-2'>
                                <input type="checkbox" defaultChecked={this.state.inviteEditPermission == 1 ? true : false} onChange={e => this.state.inviteEditPermission = (e.target.checked ? 1 : 0)} className="border-gray-300 rounded dark:border-light-700 text-brand dark:text-brand-dark ml-2" />
                                <label className='font-bold'>این کاربر مجاز به تغییر در محتوای پرسشنامه است</label>
                            </p>
                            <a className='hand mx-2 p-3 rounded bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.sendUserInvite()}> ارسال دعوتنامه </a>
                        </div>
                        {!this.isEmpty(this.state.data.users) &&
                            <div>
                                <p>لیست اعضایی که دعوت شما را تایید کرده اند</p>
                                {this.state.data.users.map(user =>
                                    user.status == 1 ?
                                        <div><b>{user.RealPerson.fname} {user.RealPerson.fname}</b> <small>({user.editPermission === 1 ? <span>دارای حق ویرایش</span> : <span>بدون دسترسی ویرایش</span>})</small></div>
                                        : null
                                )}
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    }
    sendUserInvite() {
        
        this.httpPost('api/v1/questionnaire/invite_user/', {
            id: this.state.data.record.id,
            inviteMobileNo: this.state.inviteMobileNo,
            editPermission: this.state.inviteEditPermission,
        })
            .then((data) => {

                if (data.status == 1) {
                    this.showSuccessMessage("درخواست دعوت نامه شما با موفقیت ثبت و ارسال شد.");
                    this.setState({ inviteMobileNo: '', inviteEditPermission: 0 });
                }
                else {
                    this.showErorrMessage(data.message);
                }
            });
    }
    renderIframePopup() {
        if (this.isNull(this.state.iframe)) return null;
        if (this.state.iframe != 1) return null;

        var iframe = `<iframe src="https://panel.domain.com/q/` + this.state.data.record.id + `/embeded/" style="position:absolute;top:0;bottom:0;left:0;width:100%;height:100%;border:0;" frameborder="0" scrolling="no" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>`;
        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "width": "320px", "background-color": "white", "border-radius": "8px", "padding": "20px", "position": "relative" }}>
                <a style={{ "position": "absolute", "top": "6px", "left": "0" }} className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ iframe: null })}> بستن </a>
                <p className='font-bold mt-8'>با قرار دادن کد زیر در وب سایت خود میتوانید فرم پرسشنامه را در داخل سایت خود نمایش دهید</p>
                <div className='ltr text-left text-l border p-4 mt-4 rounded font-bold' style={{ "overflow-wrap": "anywhere" }}>{iframe}</div>
                <p className='font-bold mt-8 mb-2'>لینکهای به اشتراک گذاری در شبکه های اجتماعی</p>
                <div className="flex space-x-3 rtl:space-x-reverse">
                    <a href={'https://twitter.com/intent/tweet?text=&url=https://panel.domain.com/q/' + this.state.data.record.id} target="_blank">
                        <svg className="w-8 h-8 text-indigo-600 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                            <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />{' '}
                        </svg>
                    </a>
                    <a href={'https://www.facebook.com/sharer/sharer.php?u=https://panel.domain.com/q/' + this.state.data.record.id} target="_blank">
                        <svg className="w-8 h-8 text-indigo-800 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                            <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z" />
                        </svg>
                    </a>
                    <a href={'https://telegram.me/share/url?url=https://panel.domain.com/q/' + this.state.data.record.id} target="_blank">
                        <svg className="w-8 h-8 text-blue-500 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512">
                            <path d="M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    }
    getBrowsersChart() {
        let labels = [];
        let counts = [];

        this.state.reportData.browsers.forEach(_s => {
            labels.push(_s.browser);
            counts.push(_s.count);
        });
        var bardata = {
            labels: labels,
            datasets: [
                {
                    backgroundColor: ['#ff9800', '#ffc107', '#ffeb3b', '#cddc39', '#8bc34a', '#00bcd4', '#00bcd4', '#03a9f4', '#673ab7', '#9c27b0', '#f44336',
                        '#4caf50', '#9e9e9e', '#607d8b', '#e91e63', '#2196f3', '#3f51b5', '#009688', '#795548', , '#ff5722'],
                    borderColor: 'black',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: counts
                }
            ]
        };
        return bardata;
    }
    getOsChart() {
        let labels = [];
        let counts = [];

        this.state.reportData.os.forEach(_s => {
            labels.push(_s.os);
            counts.push(_s.count);
        });
        var bardata = {
            labels: labels,
            datasets: [
                {
                    backgroundColor: ['#f44336', '#9c27b0', '#673ab7', '#03a9f4', '#00bcd4', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#9e9e9e', '#607d8b', '#e91e63', '#2196f3', '#3f51b5', '#009688', '#4caf50'],
                    borderColor: 'black',
                    borderWidth: 1,
                    hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    hoverBorderColor: 'rgba(255,99,132,1)',
                    data: counts
                }
            ]
        };
        return bardata;
    }
    renderReportPopup() {

        if (this.isNull(this.state.reports)) return null;
        if (this.state.reports != 1) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "height": "94%", "max-width": "98%", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <a style={{ "position": "absolute", "top": "6px", "left": "0px" }} className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ reports: null })}> بستن </a>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-4 border rounded p-2 text-center mt-4'>
                    <div className='flex flex-col border rounded p-2 text-right'>
                        <div className='flex flex-col w-full'>
                            <span className='mt-2'>تعداد کل مشارکت کنندگان <b>{this.money(this.state.reportData.summary.fillCount)} نفر</b></span>
                            <span className='mt-2'>تعداد کل مشارکت کنندگان عضو <b>{this.money(this.state.reportData.summary.signedUser)} نفر</b></span>
                        </div>
                        <div className='flex flex-col w-full'>
                            <span className='mt-2'>مجموع کل امتیازات کمی اخذ شده <b>{this.money(this.state.reportData.summary.sumTotalPoint)} امتیاز</b></span>
                            <span className='mt-2'>مجموع تعداد پاسخ های کیفی اخذ شده <b>{this.money(this.state.reportData.summary.sumTotalTextResponsive)} پاسخ</b></span>
                        </div>
                        <div className='flex flex-col w-full'>
                            <span className='mt-2'>مجموع کل زمان صرف شده برای پاسخ گویی <b>{this.money(Math.round(this.state.reportData.summary.sumTotalTimeToResponse / 60))} دقیقه</b></span>
                            <span className='mt-2'>تعداد سوالات <b>{this.money(this.state.data.record.questions.length)} سوال</b></span>
                        </div>
                    </div>
                    <div className='p-2 border rounded'>
                        <p className='font-b'>سیستم عامل های مشارکت کنندگان</p>
                        <Pie data={this.getOsChart()} />
                    </div>
                    <div className='p-2 border rounded'>
                        <p className='font-b'>مرورگرهای مشارکت کنندگان</p>
                        <Pie data={this.getBrowsersChart()} />
                    </div>
                </div>
                <div className='flex flex-col border rounded p-2 mt-4'>
                    <p className='font-b mb-4 text-xl'>نتایج تجمیعی سوالات کمی از مشارکت کنندگان</p>
                    {this.state.data.record.questions.map(question =>
                        <div className='mb-8'>
                            {this.renderQuestionReport(question)}
                        </div>
                    )}
                </div>
            </div>
        </div>
    }
    getIframe() {
        this.setState({ activeQuestionWindow: null, startPage: null, finishPage: null, prizePage: null, emailPage: null, conditions: null, settings: null, flowchart: null, reports: null, iframe: 1, questionIdToRemove: null });
    }
    getReport() {        
        this.httpPost('api/v1/questionnaire/report/', { id: this.state.data.record.id })
        .then((reportData) => {
            this.setState({
                reportData: reportData.record,
                activeQuestionWindow: null,
                startPage: null, finishPage: null,
                prizePage: null, emailPage: null, conditions: null, settings: null, flowchart: null,
                reports: 1, iframe: null, questionIdToRemove: null
            });
        });
    }
    getOptionValueFromFill(questionId, optionId = null, columnId = null) {
        var sumPoint = 0;
        var fillCount = 0;
        this.state.reportData.resualts.forEach(r => {
            if (optionId == null) {
                if (r.questionId == questionId) {
                    sumPoint += parseInt(r.sum_value);
                    fillCount += parseInt(r.fillCount);
                }
            }
            else {
                if (columnId == null) {
                    if (r.questionId == questionId && r.optionId == optionId) {
                        sumPoint += parseInt(r.sum_value);
                        fillCount += parseInt(r.fillCount);
                    }
                }
                else {
                    if (r.questionId == questionId && r.optionId == optionId && r.columnId == columnId) {
                        sumPoint += parseInt(r.sum_value);
                        fillCount += parseInt(r.fillCount);
                    }
                }
            }
        })
        return { sumPoint, fillCount }
    }
    renderQuestionReport(question) {
        if (question.fieldType == 7) return null;
        var html = [];
        html.push(<div className='mb-2'>
            <p className="hand flex flex-wrap text-black">{question.required === 1 ? <span className='text-red-400'>* </span> : null}<span className='px-1' dangerouslySetInnerHTML={{ __html: question.question }}></span></p>
            <small>{question.questionDesc}</small>
        </div>);

        if (question.fieldType === 1) {
            var optionFill = this.getOptionValueFromFill(question.id);

            if ((question.format == 2 || question.format == 3) && question.pointEnable == 1)
                html.push(<p><b>{this.money(optionFill.fillCount)} نفر</b><b>{this.money(optionFill.sumPoint)} امتیاز</b></p>);
            else
                html.push(<p><b>{this.money(optionFill.fillCount)} نفر</b></p>);
        }
        if (question.fieldType === 2) {
            question.options.forEach(op => {
                var optionFill = this.getOptionValueFromFill(question.id, op.id);

                if (((question.format == 1 || question.format == 2 || question.format == 3) && question.pointEnable == 1) || question.format == 5)
                    html.push(<p>{op.text} <b>{this.money(optionFill.fillCount)} نفر</b><b>{this.money(optionFill.sumPoint)} امتیاز</b></p>);
                else
                    html.push(<p>{op.text} <b>{this.money(optionFill.fillCount)} نفر</b></p>);
            });
        }
        if (question.fieldType === 4) {
            var head = [];
            var body = [];

            var columns = question.columns;
            head.push(<th className='p-2'> </th>);
            columns.forEach(c => {
                head.push(<th className='p-2'>{c.caption}</th>);
            });

            question.options.forEach((op, index) => {
                var row = [];
                row.push(<td className='p-2'><p>{op.text}</p></td>);
                columns.forEach(c => {
                    var optionFill = this.getOptionValueFromFill(question.id, op.id, c.id);

                    if (((question.format == 1 || question.format == 2) && question.pointEnable == 1) || question.format == 5)
                        row.push(<td className='p-2'><p><b>{this.money(optionFill.fillCount)} نفر</b><b>{this.money(optionFill.sumPoint)} امتیاز</b></p></td>);
                    else
                        row.push(<td className='p-2'><p><b>{this.money(optionFill.fillCount)} نفر</b></p></td>);
                });
                body.push(<tr>{row}</tr>);
            });

            html.push(<table className='text-center'>
                <thead><tr>{head}</tr></thead>
                <tbody>{body}</tbody>
            </table>)
        }
        return html;
    }
    renderQuestionRemovePopup() {
        if (this.isNull(this.state.questionIdToRemove)) return null;

        return <div style={{ "position": "fixed", "width": "100%", "background-color": "#0000008c", "top": "0", "left": "0", "height": "100%", "z-index": "10000" }}>
            <div style={{ "margin": "1% auto", "overflow-y": "scroll", "max-width": "580px", "background-color": "white", "border-radius": "8px", "padding": "35px", "position": "relative" }}>
                <p className='font-b mt-8'>با حذف این سوال تمام پاسخ های ثبت شده برای آن نیز حذف می شود. آیا ادامه میدهید؟</p>
                <div className='mt-8 text-center'>
                    <a className='hand btn btn-danger me-2' onClick={e => this.doRemoveQuestion()}>بله حذف شود </a>
                    <a className='hand btn bg-gray-400 text-white transition-all duration-200 ease-in-out' onClick={e => this.setState({ questionIdToRemove: null })}> خیر - برگشت </a>
                </div>
            </div>
        </div>
    }
    //componentWillReceiveProps(props) {
    //    if (props.Id === this.state.id) return;
    //    this.state.id = props.Id;
    //    this.getData();
    //}
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.getData();
            });
    }
    getData() {
        this.httpPost("api/v1/questionnaire/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 0) {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
            else {
                window.companyId = data.global.company.id;
                data = this.jsonConverts(data);
                this.setState({
                    data: data,
                    loading: false
                })
            }
        });
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                            {this.renderQuestionPopup()}
                            {this.renderStartPagePopop()}
                            {this.renderFinishPagePopop()}
                            {this.renderPrizePagePopop()}
                            {this.renderEmailPagePopop()}
                            {this.renderConditionsPopup()}
                            {this.renderSettingsPopop()}
                            {this.renderFlowChartPopop()}
                            {this.renderReportPopup()}
                            {this.renderIframePopup()}
                            {this.renderQuestionRemovePopup()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}